export const user = [
    {
        "nomComplet": "Oumar Diallo",
        "categorie": "Mineur",
        "cotisation": "10000 FCFA",
        "date": "06/01/2025",
        "Etat": "actif"
    },
    {
        "nomComplet": "Daouda Traoré",
        "categorie": "Majeur",
        "cotisation": "20000 FCFA",
        "date": "08/01/2025",
        "Etat": "suspendu"
    },
    {
        "nomComplet": "Hamadoun Sankaré",
        "categorie": "Mineur",
        "cotisation": "30000 FCFA",
        "date": "04/01/2025",
        "Etat": "en attente"
    },
    {
        "nomComplet": "Paul Diassana",
        "categorie": "Majeur",
        "cotisation": "40000 FCFA",
        "date": "06/01/2025",
        "Etat": "suspendu"
    },
    {
        "nomComplet": "Ibrahima Koné",
        "categorie": "Mineur",
        "cotisation": "10.000 FCFA",
        "date": "06/01/2025",
        "Etat": "actif"
    },
    {
        "nomComplet": "Tafsir Maiga",
        "categorie": "Majeur",
        "cotisation": "10.000 FCFA",
        "date": "06/01/2025",
        "Etat": "suspendu"
    },
]